@if (!isReadonly) {
  <et-step-layout [data]="data">
    @if (paperDetails?.countOfDocuments) {
      <div paper-toolbar>
        <p-button (onClick)="showFileHistoryListDialog()"
                  styleClass="p-button-link"
                  label="Paper history ({{ paperDetails?.countOfDocuments }})"
                  i18n-label>
        </p-button>
      </div>
    }
    <div class="flex flex-column align-items-center">
      <span class="title3Font mb-2"
            i18n>Paper</span>
      <span class="body2Font"
            i18n>Upload files of a new manuscript. All files should be prepared in the manuscript.</span>
      <div class="w-7 flex flex-column align-items-center">
        <div class="w-full flex justify-content-between mt-5">
          <div class="flex flex-column w-5">
            <sc-file-upload #docUploader
                            [requestInProcess$]="uploadFilesInProcess$"
                            [progress$]="uploadFilesProgress$"
                            [uploadErrors$]="uploadFilesErrors$"
                            [validationRules]="data.docValidationRules$ | async">
            </sc-file-upload>
            @if (paperDetails && paperDetails.doc) {
              <sc-file-download class="mt-5 align-self-center"
                                [fileInfo]="paperDetails.doc.file"
                                [download$]="downloadDocFile$">
              </sc-file-download>
            }
          </div>
          <div class="flex flex-column w-5 ml-5">
            <sc-file-upload #pdfUploader
                            [requestInProcess$]="uploadFilesInProcess$"
                            [progress$]="uploadFilesProgress$"
                            [uploadErrors$]="uploadFilesErrors$"
                            [validationRules]="data.pdfValidationRules$ | async">
            </sc-file-upload>
            @if (paperDetails && paperDetails.pdf) {
              <sc-file-download class="mt-5 align-self-center"
                                [fileInfo]="paperDetails.pdf.file"
                                [download$]="downloadPdfFile$">
              </sc-file-download>
            }
          </div>
        </div>
        <span class="mt-5"
              i18n><i class="fas fa-lg fa-exclamation-circle mr-2 sc-red"></i>Uploaded files should be less than
          64Mb</span>
        <p-button [loading]="uploadFilesInProcess$ | async"
                  [disabled]="!canUploadFiles"
                  (onClick)="startUpload()"
                  class="mt-6"
                  label='Upload'
                  i18n-label>
        </p-button>
        @if (paperDetails) {
          <div class="mt-5 mb-9 w-full">
            <form [formGroup]="form">
              <div class="field mb-6">
                <label class="font-bold sc-required-input"
                       i18n>Paper Title</label>
                <!-- Using of disabled attribute in Reactive Forms available after bugfix:
                https://github.com/tinymce/tinymce-angular/issues/142 -->
                <editor scValidatable
                        formControlName="name"
                        [formattingTagsOnly]="true">
                </editor>
              </div>
              <div class="field mb-6">
                <label class="font-bold sc-required-input"
                       i18n>Abstract</label>
                <!-- Using of disabled attribute in Reactive Forms available after bugfix:
                https://github.com/tinymce/tinymce-angular/issues/142 -->
                <editor scValidatable
                        formControlName="abstract"
                        [formattingTagsOnly]="true">
                </editor>
              </div>
              <ng-template *ngTemplateOutlet="contentTpl; context: { $implicit: externalFormControls, paperDetails }">
              </ng-template>
              <p-button styleClass="et-button-width-12"
                        [disabled]="isSubmitDisabled"
                        [loading]="updateDetailsInProcess"
                        (onClick)="updateDetails()"
                        label="Save"
                        i18n-label>
              </p-button>
            </form>
          </div>
        }
      </div>
    </div>
  </et-step-layout>
} @else {
  <et-step-layout [data]="data">
    @if (paperDetails?.countOfDocuments) {
      <div paper-toolbar>
        <p-button (onClick)="showFileHistoryListDialog()"
                  styleClass="p-button-link ml-2"
                  label="Paper history ({{ paperDetails?.countOfDocuments }})"
                  i18n-label>
        </p-button>
      </div>
    }
    <div class="flex flex-column align-items-center">
      <span class="title3Font mb-2"
            i18n>Paper</span>
      <div class="w-7 flex flex-column align-items-center">
        <div class="w-full flex justify-content-between mt-5">
          <div class="flex flex-column w-5">
            @if (paperDetails) {
              <sc-file-download class="mt-5 align-self-center"
                                [fileInfo]="paperDetails.doc.file"
                                [download$]="downloadDocFile$">
              </sc-file-download>
            }
          </div>
          <div class="flex flex-column w-5 ml-5">
            @if (paperDetails) {
              <sc-file-download class="mt-5 align-self-center"
                                [fileInfo]="paperDetails.pdf.file"
                                [download$]="downloadPdfFile$">
              </sc-file-download>
            }
          </div>
        </div>
        @if (paperDetails) {
          <div class="mt-5 mb-9 w-full">
            <form [formGroup]="form">
              <div class="field mb-6">
                <label class="font-bold sc-required-input"
                       i18n>Paper Title</label>
                <!-- Using of disabled attribute in Reactive Forms available after bugfix:
                https://github.com/tinymce/tinymce-angular/issues/142 -->
                <editor formControlName="name"
                        [disabled]="true">
                </editor>
              </div>
              <div class="field mb-6">
                <label class="font-bold sc-required-input"
                       i18n>Abstract</label>
                <!-- Using of disabled attribute in Reactive Forms available after bugfix:
                https://github.com/tinymce/tinymce-angular/issues/142 -->
                <editor formControlName="abstract"
                        [disabled]="true">
                </editor>
              </div>
              <ng-template *ngTemplateOutlet="contentTpl; context: { $implicit: externalFormControls, paperDetails }">
              </ng-template>
            </form>
          </div>
        }
      </div>
    </div>
  </et-step-layout>
}